<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">SAP Query</h4>
          <p class="card-subtitle">
            Execute custom SAP Business One Service Layer queries
          </p>
        </div>
        <div class="card-body">
          <form [formGroup]="queryForm" (ngSubmit)="onSubmit()">
            <div class="row mb-3">
              <div class="col-md-3">
                <label for="method" class="form-label">HTTP Method *</label>
                <select
                  class="form-select"
                  id="method"
                  formControlName="method">
                  <option
                    *ngFor="let method of httpMethods"
                    [value]="method.value">
                    {{ method.label }}
                  </option>
                </select>
              </div>
              <div class="col-md-9">
                <label for="description" class="form-label"
                  >Description (Optional)</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="description"
                  formControlName="description"
                  placeholder="Describe what this query does..." />
              </div>
            </div>

            <div class="mb-3">
              <label for="query" class="form-label"
                >SAP Service Layer Endpoint *</label
              >
              <input
                type="text"
                class="form-control"
                id="query"
                formControlName="query"
                placeholder="e.g., Items('1007607') or Items?$select=ItemCode,ItemName&$top=10" />
              <small class="text-muted d-block">
                Enter the endpoint path without the base URL. Examples:
              </small>
              <small class="text-muted">
                • GET: <code>Items?$select=ItemCode,ItemName&$top=10</code
                ><br />
                • GET: <code>Items('1007607')</code><br />
                • PATCH: <code>Items('1007607')</code> (with JSON body)<br />
                • POST: <code>Items</code> (with JSON body for new item)<br />
                • DELETE: <code>Items('1007607')</code>
              </small>
            </div>

            <div class="mb-3" *ngIf="showRequestBody">
              <label for="requestBody" class="form-label"
                >Request Body (JSON)</label
              >
              <textarea
                class="form-control font-monospace"
                id="requestBody"
                formControlName="requestBody"
                rows="10"
                placeholder='{"field": "value"}'></textarea>
              <small class="text-muted">
                For PATCH to update bin location:
                <code>{{
                  '{"ItemWarehouseInfoCollection": [{"WarehouseCode": "01", "U_DfltBin": "A-01-02,B-03-04"}]}'
                }}</code>
              </small>
            </div>

            <div class="d-flex gap-2">
              <button
                type="submit"
                class="btn btn-primary"
                [disabled]="!queryForm.valid || loading">
                <span
                  *ngIf="loading"
                  class="spinner-border spinner-border-sm me-2"
                  role="status"></span>
                {{ loading ? 'Executing...' : 'Execute Query' }}
              </button>

              <button
                type="button"
                class="btn btn-secondary"
                (click)="clearResult()"
                [disabled]="!result && !error">
                Clear Result
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Results Section -->
  <div class="row mt-4" *ngIf="result || error">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h5 class="card-title">Query Result</h5>
        </div>
        <div class="card-body">
          <!-- Error Display -->
          <div *ngIf="error" class="alert alert-danger">
            <h6>Error:</h6>
            <pre>{{ error }}</pre>
            <span *ngIf="executionTime !== null">
              <small class="text-muted"
                >Failed after {{ (executionTime / 1000).toFixed(2) }}s</small
              >
            </span>
          </div>

          <!-- Success Result Display -->
          <div *ngIf="result && !error">
            <div class="alert alert-success">
              <strong>Query executed successfully!</strong>
              <span *ngIf="result.value">
                - {{ result.value.length }} records returned</span
              >
              <span *ngIf="executionTime !== null">
                - Execution time: {{ (executionTime / 1000).toFixed(2) }}s
              </span>
            </div>

            <div class="mt-3">
              <h6>Raw JSON Response:</h6>
              <pre class="bg-light p-3 rounded">{{ formatJSON(result) }}</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
